import classes from '../main.module.css'
import React, { useState, useEffect } from "react";

const Home = ({ onContactClick }) => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (e) => {
            const x = (e.clientX / window.innerWidth - 0.5);
            const y = (e.clientY / window.innerHeight - 0.5);
            setMousePos({ x, y });
        };
        window.addEventListener("mousemove", handleMouseMove);
        return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);

    const parallaxSlow = {
        transform: `translate3d(${mousePos.x * -20}px, ${mousePos.y * -20}px, 0)`
    };

    const parallaxFast = {
        transform: `translate3d(${mousePos.x * -45}px, ${mousePos.y * -45}px, 0)`
    };

    return (
        <main className={classes.LuxuryMain}>
            <section id="home" className={classes.LuxuryHome}>
                {/* Subtle Luxury Background */}
                <div className={classes.LuxuryGradient}></div>

                <div className={`${classes.LuxuryContainer} ${classes.Container}`}>
                    {/* Typography Centric Left Side */}
                    <div className={classes.LuxuryContent}>
                        <div className={classes.LuxuryMicroTag}>
                            <div className={classes.LuxuryDot}></div>
                            <span>World-Class Engineering</span>
                        </div>

                        <h1 className={classes.LuxuryTitle}>
                            Crafting Digital <br />
                            <span className={classes.LuxuryTitleAccent}>Excellence.</span>
                        </h1>

                        <p className={classes.LuxurySubtitle}>
                            Feline is a specialized development team transforming visionary concepts into high-performance, elegant software solutions.
                        </p>

                        <div className={classes.LuxuryActions}>
                            <button className={classes.LuxuryButtonPrimary} onClick={onContactClick}>
                                Start a Conversation
                            </button>
                            <a href="#case-studies" className={classes.LuxuryButtonLink} style={{ textDecoration: 'none' }}>
                                Explore our work &rarr;
                            </a>
                        </div>
                    </div>

                    {/* Minimalist Glass Parallax Right Side */}
                    <div className={classes.LuxuryVisuals}>
                        <div className={classes.GlassCardBase} style={parallaxSlow}>
                            <div className={classes.GlassHeader}>
                                <div className={classes.GlassDotGroup}>
                                    <span></span><span></span><span></span>
                                </div>
                            </div>
                            <div className={classes.GlassBody}>
                                <div className={classes.FakeTextLine}></div>
                                <div className={classes.FakeTextLineShort}></div>
                                <div className={classes.FakeGraph}>
                                    <div className={classes.GraphBar1}></div>
                                    <div className={classes.GraphBar2}></div>
                                    <div className={classes.GraphBar3}></div>
                                </div>
                            </div>
                        </div>

                        <div className={classes.GlassCardAccent} style={parallaxFast}>
                            <div className={classes.AccentData}>
                                <span className={classes.AccentNumber}>2+</span>
                                <span className={classes.AccentLabel}>Years of Elegance</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Home